@if (severity && customSeverities) {
  <div class="ds-severity-cell">
    <ds-chip
      [text]="severityText"
      [colorVariant]="severityChipVariant"
      [showIcon]="severityIcon"
      [iconPosition]="DsChipIconPosition.Left"
      [iconName]="severityIcon"
      [iconStyle]="IconStyles.Regular"
      [iconColor]="severityIconColor"
    ></ds-chip>
  </div>
}
